export default class UnauthorizedException extends Error {
  public isUnauthorizedException: boolean = true;
}
